const styles = {
    steps: {
        "& >*": {
            marginBottom: 12,
        },
    },
}

export default styles
